import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from 'components/common/Firebase';
import { AuthorizedUserContext } from 'components/common/AuthorizedUser';

export const UserDataContext = React.createContext();
export const UserDataProvider = props => {
  const firebase = useContext(FirebaseContext);
  const authorizedUser = useContext(AuthorizedUserContext);

  const initialState = {
    error: false,
    fetching: false,
    loaded: false,
    userData: null
  };

  const [state, setState] = useState(initialState);

  const listenToUserData = authorizedUser => {
    setState({ fetching: true });
    if (authorizedUser != null) {
      firebase.user(authorizedUser.uid).on(
        'value',
        function(snapshot) {
          const userData = snapshot.val();
          if (userData) {
            setState({
              userData: userData,
              error: false,
              loaded: true,
              fetching: false
            });
          }
        },
        function(errorObject) {
          console.log('The read failed: ' + errorObject.code);
        }
      );
    }
  };

  const stopListening = authorizedUser => {
    if (authorizedUser != null) {
      firebase.user(authorizedUser.uid).off();
    }
  };

  useEffect(() => {
    // Runs when any prop changes
    listenToUserData(authorizedUser);
    return () => {
      // cleanup function
      stopListening(authorizedUser);
    };
  }, [authorizedUser]);

  return (
    <UserDataContext.Provider value={state.userData}>
      {props.children}
    </UserDataContext.Provider>
  );
};
